import { withProps, ExternalLink } from '@cast/design-system';
import { Linkify as _Linkify } from '@cast/utils';

export const Linkify = withProps(_Linkify, {
  componentDecorator: (href: string, text: string, key: number) => (
    <ExternalLink link={href} key={key}>
      {text}
    </ExternalLink>
  ),
});
